import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ProfileVector from "@/views/ProfileVector";
import ProfileTypes from "@/views/ProfileTypes";
import ProfileData from "@/views/ProfileData";
import ConsumptionInfoModal from "@/views/ConsumptionInfoModal";
import CostInfoModal from "@/views/CostInfoModal";
import Score from "@/views/Score";
import Login from "@/views/Login";
import VerifyPin from "@/views/VerifyPin";
import Report from "@/views/Report";
import Recall from "@/views/Recall";
import NotFound from "@/views/NotFound";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/vector',
    name: 'Vectors',
    component: ProfileVector
  },
  {
    path: '/types',
    name: 'Types',
    component: ProfileTypes
  },
  {
    path: '/profile',
    component: ProfileData,
    children: [
      {
        path: 'consumption-info',
        component: ConsumptionInfoModal
      },
      {
        path: 'cost-info',
        component: CostInfoModal
      }
    ]
  },
  {
    path: '/score',
    name: 'Score',
    component: Score
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: true
  },
  {
    path: '/verify_pin',
    name: 'VerifyPin',
    component: VerifyPin
  },
  {
    path: '/report',
    name: 'Report',
    component: Report
  },
  {
    path: '/recall',
    name: 'Recall',
    component: Recall
  },
  {
    path: '/404',
    component: NotFound
  },
  {
    path: '*',
    redirect: '/404'
  },
]

const router = new VueRouter({
  routes
})

export default router
